import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { RECURRING_INTERVALS } from "../models/Reminder.jsx";
import { EntityMainNameDefault } from "../../other/utils/utils.jsx";

export default class RecurringIntervalColumn extends SwivuSortColumn {
  static get $name() {
    return "RecurringIntervalColumn"
  }

  static get type() {
    return WIDGET_KEYS.recurringIntervalColumn;
  }

  static get defaults() {
    return {
      text: "Recurring",
      field: "recurringIntervalValue",
      minWidth: 100,
      editor: false,
      groupable: false,
      renderer: ({ value }) => EntityMainNameDefault({ text: value })
    }
  }

  get canEmptySwivuList() {
    return false;
  }

  get swivuListTitle() {
    return "Recurring"
  }

  get swivuListItems() {
    return RECURRING_INTERVALS;
  }

  getSwivuListItemDisplayValue(record) {
    return `<span>${record.value}</span>`;
  }

  getSelectedSwivuListItem(record) {
    const recurringIntervalId = record.recurringInterval;
    return RECURRING_INTERVALS.find(interval => interval.id === recurringIntervalId)
  }

  onSwivuListSelectionChange(record, [recurringRecord]) {
    record.recurringInterval = recurringRecord.id;
    record.repeatCount = recurringRecord.defaultCount;
  }
}

ColumnStore.registerColumnType(RecurringIntervalColumn);
